import React, { useEffect, useState } from "react";
import Fileupload from "../../components/Fileupload";
import { useParams } from "react-router-dom";
import { getStage, send_excel_validation } from "../../api/api";
import * as XLSX from "xlsx";
import { toast } from "react-toastify";

const Alttext = ({ fileId, renderpage }) => {
  const [file, setFile] = useState([]);
  const [fileName, setFileName] = useState("");
  const [stage, setStage] = useState();

  const { category } = useParams();

  useEffect(() => {
    getstage();
  }, []);

  const getstage = async () => {
    let data = await getStage(fileId, category);
    if (data.data) {
      console.log(data);
      setStage({
        previous: data.data.previous_process,
        next: data.data.next_process,
      });
    }
  };

  const senddata = async (event) => {
    const button = event.currentTarget;
    button.disabled = true; // Disable the button
    document.body.style.cursor = "wait";
    try {
      if (file.length > 0) {
        event.currentTarget.disabled = true;
        document.body.style.cursor = "wait";
        let response = await send_excel_validation(
          fileId,
          file,
          category,
          fileName
        );
        if (response.data) {
          document.body.style.cursor = "default";
          handleNext(fileId, stage.next);
        } else {
          // alert(response.error.message);
          toast.error(response.error.message);
          document.body.style.cursor = "default";
          button.disabled = false;
        }
      } else {
        // alert("Please upload a file to continue");
        toast.warn("Please upload a file to continue");
        document.body.style.cursor = "default";
        button.disabled = false;
      }
    } catch (e) {
      // console.log(e);
      toast.error(e);
      document.body.style.cursor = "default";
      button.disabled = false;
    }
  };

  const skipstage = async (event) => {
    try {
      document.body.style.cursor = "wait";
      let response = await send_excel_validation(fileId, file, category, "");
      if (response.data) {
        document.body.style.cursor = "default";
        handleNext(fileId, stage.next);
      } else {
        // alert(response.error.message);
        toast.error(response.error.message);
        document.body.style.cursor = "default";
      }
    } catch (e) {
      // console.log(e);
      toast.error(e);
      document.body.style.cursor = "default";
    }
  };

  const handleNext = (fileId, nextpage) => {
    renderpage(fileId, nextpage);
  };

  // const handleDownload = () => {
  //   const csv = convertJSONToCSV(jsonData);
  //   console.log(csv);
  //   downloadCSVFile(csv);
  // };

  // const convertJSONToCSV = (data) => {
  //   const keys = Object.keys(data[0]);
  //   const csvrows = [
  //     keys,
  //     // ...data.map((row) =>
  //     //   keys.map((key) => JSON.stringify(row[key], null, "")).join(",")
  //     // ),
  //   ];
  //   return csvrows;
  // };

  const handleDownloadXLSX = () => {
    const headers = [
      "S.No",
      "Page #",
      "Image Name",
      "Thumbnail",
      "Short Description",
      "Long Description",
      "Category",
    ];
    // const rows = [
    //   ["John Doe", 25, "john@example.com"],
    //   ["Jane Doe", 30, "jane@example.com"],
    // ];

    const worksheet = XLSX.utils.aoa_to_sheet([headers]);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Template");

    // Write to Excel file and trigger download
    XLSX.writeFile(workbook, "Template.xlsx");
    toast.success("Template downloaded successfully");
  };

  // const downloadCSVFile = (csvfile, filename = "template.xlsx") => {
  //   const blob = new Blob([csvfile], { type: "text/xls;charset=utf-8;" });
  //   const link = document.createElement("a");
  //   const url = URL.createObjectURL(blob);

  //   link.setAttribute("href", url);
  //   link.setAttribute("download", filename);
  //   link.style.visibility = "hidden";

  //   document.body.appendChild(link);
  //   link.click();
  //   document.body.removeChild(link);
  // };

  return (
    <div className="flex w-full">
      <div className="p-8 flex flex-col gap-8 h-[100%] min-h-[70vh] w-full">
        <div className="flex w-full justify-between text-left items-center">
          <h1 className="text-24 font-semibold">Alt Text Integration</h1>
          <button
            onClick={() => handleDownloadXLSX()}
            className="flex gap-2 px-3 py-3 border-[1.5px] border-highlighttext rounded-[12px] bg-white"
          >
            <img
              src={process.env.PUBLIC_URL + "/images/downloadicon.svg"}
              alt="editor_logo"
            ></img>
            <p className="text-highlighttext text-14 font-semibold">
              Download Template
            </p>
          </button>
        </div>
        <div className="w-full shadow-commonshadow rounded-[24px]">
          <Fileupload
            setFiles={setFile}
            setFileName={setFileName}
            category={category}
          />
        </div>
        <div className="flex mt-20 gap-5 ml-auto">
          <button
            onClick={(event) => {
              handleNext(fileId, stage.previous);
            }}
            className="w-fit flex "
          >
            <p className="py-3 px-6 rounded-[12px] text-white bg-highlight text-14 font-bold">
              PREV
            </p>
          </button>
          <button
            onClick={(event) => {
              skipstage(event);
            }}
            className="w-fit flex justify-end"
          >
            <p className="py-3 px-6 rounded-[12px] text-highlight border-[1px] border-highlightblue bg-white text-14 font-bold">
              SKIP
            </p>
          </button>
          <button
            onClick={(event) => {
              senddata(event);
            }}
            className="w-fit flex justify-end"
          >
            <p className="py-3 px-6 rounded-[12px] text-white bg-highlight text-14 font-bold">
              NEXT
            </p>
          </button>
        </div>
      </div>
    </div>
  );
};

export default Alttext;
